import apiClient from './apiClient';
import { API_ENDPOINTS } from '../redux/constants/authConstants';

export const authApi = {
  login: async (credentials) => {
    const response = await apiClient.post(API_ENDPOINTS.LOGIN, credentials);
    return response.data;
  },

  logout: async () => {
    const response = await apiClient.post(API_ENDPOINTS.LOGOUT);
    return response.data;
  },

  forgotPassword: async (email) => {
    const response = await apiClient.post(API_ENDPOINTS.FORGOT_PASSWORD, { email });
    return response.data;
  },

  verifyResetToken: async (resetToken, email) => {
    const response = await apiClient.get(`${API_ENDPOINTS.VERIFY_RESET_TOKEN}?resetToken=${resetToken}&email=${encodeURIComponent(email)}`);
    return response.data;
  },

  resetPassword: async (resetToken, email, newPassword) => {
    const response = await apiClient.post(API_ENDPOINTS.COMPLETE_PASSWORD_RESET, {
      resetToken,
      email,
      newPassword
    });
    return response.data;
  }
};